// src/screens/DashboardScreen.jsx
import { C, levelColor, urgencyColor } from "../styles/tokens";
import { Icon, Badge, BloodBadge, ProgressBar } from "../components/UI";
import { INVENTORY, REQUESTS, DONORS } from "../data/mockData";

export default function DashboardScreen({ setActive }) {
  const stats = [
    { label: "Total Units",    value: "66", icon: "drop",      color: C.blue,    sub: "+4 today"    },
    { label: "Active Requests",value: "12", icon: "send",      color: C.orange,  sub: "3 Emergency" },
    { label: "Nearby Donors",  value: "38", icon: "people",    color: C.green,   sub: "24 available" },
    { label: "Critical Types", value: "3",  icon: "emergency", color: C.primary, sub: "A+, B-, O-"  },
  ];

  return (
    <div className="fade-up" style={{ padding: 24, display: "flex", flexDirection: "column", gap: 20 }}>
      {/* Alert banner */}
      <div style={{ background: "rgba(198,40,40,.1)", border: "1px solid rgba(198,40,40,.3)", borderRadius: 14, padding: "13px 18px", display: "flex", alignItems: "center", gap: 12 }}>
        <Icon name="emergency" size={18} color={C.red} />
        <span style={{ color: "#EF9A9A", fontSize: 13, fontWeight: 500, flex: 1 }}>
          <strong>3 blood groups at critical level</strong> — A+, B−, O− need immediate action
        </span>
        <button className="btn-sm" onClick={() => setActive("requests")}>View Requests</button>
      </div>

      {/* Stat cards */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(160px,1fr))", gap: 14 }}>
        {stats.map((s) => (
          <div key={s.label} className="card" style={{ padding: 20, borderLeft: `3px solid ${s.color}` }}>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "flex-start", marginBottom: 12 }}>
              <div style={{ width: 36, height: 36, background: `${s.color}20`, borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center" }}>
                <Icon name={s.icon} size={18} color={s.color} />
              </div>
              <span style={{ fontSize: 11, color: s.color, background: `${s.color}15`, padding: "3px 8px", borderRadius: 20, fontWeight: 700 }}>{s.sub}</span>
            </div>
            <div className="syne" style={{ fontSize: 32, fontWeight: 900, color: C.text, lineHeight: 1 }}>{s.value}</div>
            <div style={{ fontSize: 12, color: C.muted, marginTop: 4 }}>{s.label}</div>
          </div>
        ))}
      </div>

      <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 20 }}>
        {/* Blood inventory summary */}
        <div className="card" style={{ padding: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <span className="syne" style={{ fontSize: 15, fontWeight: 800 }}>Blood Inventory</span>
            <button className="btn-sm" onClick={() => setActive("inventory")}>Manage</button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {INVENTORY.map((b) => (
              <div key={b.group} style={{ display: "flex", alignItems: "center", gap: 12 }}>
                <span style={{ width: 36, fontSize: 13, fontWeight: 900, color: levelColor(b.level) }}>{b.group}</span>
                <div style={{ flex: 1 }}><ProgressBar value={b.units} max={b.max} color={levelColor(b.level)} /></div>
                <span style={{ width: 24, textAlign: "right", fontSize: 12, fontWeight: 700, color: levelColor(b.level) }}>{b.units}</span>
                <Badge label={b.level.charAt(0).toUpperCase() + b.level.slice(1)} color={levelColor(b.level)} />
              </div>
            ))}
          </div>
        </div>

        {/* Recent requests */}
        <div className="card" style={{ padding: 20 }}>
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
            <span className="syne" style={{ fontSize: 15, fontWeight: 800 }}>Recent Requests</span>
            <button className="btn-sm" onClick={() => setActive("requests")}>View All</button>
          </div>
          <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            {REQUESTS.slice(0, 4).map((r) => (
              <div key={r.id} className="card2" style={{ padding: "11px 14px", display: "flex", alignItems: "center", gap: 12 }}>
                <BloodBadge group={r.blood} />
                <div style={{ flex: 1 }}>
                  <div style={{ fontSize: 13, fontWeight: 700, color: C.text }}>{r.patient}</div>
                  <div style={{ fontSize: 11, color: C.muted }}>{r.units} unit{r.units > 1 ? "s" : ""} · {r.time}</div>
                </div>
                <Badge label={r.urgency} color={urgencyColor(r.urgency)} />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Nearby donors */}
      <div className="card" style={{ padding: 20 }}>
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 16 }}>
          <span className="syne" style={{ fontSize: 15, fontWeight: 800 }}>Nearby Donors</span>
          <button className="btn-sm" onClick={() => setActive("donors")}>View All</button>
        </div>
        <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill,minmax(200px,1fr))", gap: 12 }}>
          {DONORS.slice(0, 4).map((d) => (
            <div key={d.id} className="card2" style={{ padding: 14 }}>
              <div style={{ display: "flex", alignItems: "center", gap: 10, marginBottom: 10 }}>
                <div style={{ width: 38, height: 38, background: "rgba(198,40,40,.15)", borderRadius: 10, display: "flex", alignItems: "center", justifyContent: "center", fontSize: 16, fontWeight: 900, color: C.red, position: "relative" }}>
                  {d.name[0]}
                  <div style={{ position: "absolute", bottom: 1, right: 1, width: 9, height: 9, borderRadius: "50%", background: d.available ? C.greenL : C.muted, border: `1.5px solid ${C.card2}` }} />
                </div>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 700, color: C.text }}>{d.name}</div>
                  <div style={{ fontSize: 11, color: C.muted }}>{d.dist} away</div>
                </div>
                <BloodBadge group={d.blood} />
              </div>
              {d.available && <button className="btn-sm" style={{ width: "100%", fontSize: 11 }}>Contact</button>}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}